// extracted by mini-css-extract-plugin
export var title = "styles-module__title___ANiV1";
export var questionAndAnswer = "styles-module__questionAndAnswer___PzU_Z";
export var noMarginBottom = "styles-module__noMarginBottom___icNfZ";
export var question = "styles-module__question___VTKw6";
export var answer = "styles-module__answer___wckLa";